import React, { useState, useContext } from 'react';
import DataContext from '../context/dataContext';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { phoneOptions } from '../filteroptions/options';
import { InView } from 'react-intersection-observer';
import { handleScroll } from '../animations/animation';
import axios from 'axios';

const RegisterForm = () => {
  const { t } = useTranslation();

  const [selectedPhone, setSelectedPhone] = useState('+93');

  // Register Form State
  const [user, setUser] = useState({
    name: '',
    email: '',
    phone: '',
  });
  const onChange = (e) => setUser({ ...user, [e.target.name]: e.target.value });
  // Phone State
  const handleChangePhone = (selectedPhone) => {
    setSelectedPhone(selectedPhone);
  };
  // İnfo Handle State
  const [info, setInfo] = useState('');

  // Form Submit
  const handleSubmit = (e) => {
    if(user.name && (user.phone || user.email)){
      axios.post(`${process.env.REACT_APP_API_URL}/postsmails`, user);
      setUser({
        name: '',
        email: '',
        phone: '',
      });
      alert("Thank you for your interest. We will contact you as soon as posible.");
    }else{
      alert("Please provide your email or phone with your name to reach you.");
    }
  };
  return (
    <InView
      onChange={(inView, entry) => {
        handleScroll(inView);
      }}
    >

      <div id='register-form'>
        <div className='container'>
          <h3>{t('REGISTER_YOUR_INTEREST')} </h3>
          <div className='row justify-content-center'>
            <div className='col-lg-5'>
              <form onSubmit={handleSubmit}>
                <div className='form-group'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder={t('ENTER_FULL_NAME')}
                    name='name'
                    value={user.name}
                    onChange={onChange}
                  />
                </div>
                <div className='form-group'>
                  <input
                    type='email'
                    className='form-control'
                    placeholder={t('ENTER_YOUR_EMAIL')}
                    name='email'
                    value={user.email}
                    onChange={onChange}
                  />
                </div>
                <div className='form-group'>
                  <div className='form-row'>
                    <div className='col-3 px-1 border-white'>
                      <Select
                        isSearchable={false}
                        onChange={handleChangePhone}
                        options={phoneOptions}
                        classNamePrefix='phonenumberfilter'
                        placeholder={
                          selectedPhone.value ? selectedPhone.value : '+93'
                        }
                        value={selectedPhone.value}
                      />
                    </div>
                    <div className='col-9'>
                      <input
                        type='number'
                        className='form-control'
                        placeholder={t('ENTER_PHONE_NUMBER')}
                        name='phone'
                        value={user.phone}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                </div>
                <button type='button' className='btn btn-light btn-block' onClick={(e) => handleSubmit()}>
                  {t('SUBMIT')}
                </button>
              </form>

              <div id='get-in-touch'>
                <h6> {t('GET_IN_TOUCH')}</h6>
                <div id='get-in-touch-items'>
                  <a href='tel:+97142149000' className='get-in-touch-item'>
                    <svg className='icon icon-phone'>
                      <path
                        d='M21.4479695,24 C22.0927865,24 22.7322933,23.4896763 22.8753927,22.8609271 L23.9624627,18.1405244 C23.983154,18.0508927 23.9999542,17.9034445 23.9999542,17.8114325 C23.9999542,17.2792731 23.6030205,16.6769831 23.1139832,16.467049 L18.0331312,14.2873241 C17.8806017,14.2223206 17.6222813,14.1695395 17.4564764,14.1695395 C17.0737794,14.1695395 16.5656072,14.4091829 16.3221643,14.7045371 L14.2549139,17.2311155 C11.4867237,15.8696572 8.13505786,12.5179914 6.77355378,9.74975538 L9.30017796,7.6825507 C9.5954406,7.43915358 9.83512977,6.93111874 9.83512977,6.54846751 C9.83512977,6.38270844 9.78234871,6.12447952 9.71734515,5.9720416 L7.53762024,0.886016796 C7.32626712,0.396933694 6.72232914,0 6.18952886,0 C6.09724212,0 5.94938191,0.0168002152 5.85947558,0.0375372655 L1.13440363,1.12978014 C0.508217953,1.27141465 0,1.90739663 0,2.54942121 L0,2.55477713 C0,14.4279515 9.62359354,24 21.4452229,24 L21.4479695,24 Z M21.4170699,22.4999743 C10.4251973,22.4859207 1.51407934,13.5795178 1.50469502,2.58759935 L6.17355263,1.50945584 L8.32983965,6.54343203 L4.91729022,9.33254241 C7.1860517,14.1701346 9.81581181,16.8092333 14.6721269,19.0874248 L17.4612372,15.6748754 L22.4952134,17.8311624 L21.4170699,22.4999743 Z'
                        id='phone'
                        fill='#fff'
                        fillRule='nonzero'
                      ></path>
                    </svg>
                    {t('CALL')}
                  </a>
                  <a
                    href='https://www.google.com.tr/maps/place/Ayana+holding/@25.2488657,55.3075912,17z/data=!3m1!4b1!4m5!3m4!1s0x3e5f43445200bf07:0xe3521a98c6bc3182!8m2!3d25.2488657!4d55.3097799'
                    target="_blank"
                    className='get-in-touch-item'
                  >
                    <svg className='icon icon-location'>
                    <path d="M12 10c-1.104 0-2-.896-2-2s.896-2 2-2 2 .896 2 2-.896 2-2 2m0-5c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3m-7 2.602c0-3.517 3.271-6.602 7-6.602s7 3.085 7 6.602c0 3.455-2.563 7.543-7 14.527-4.489-7.073-7-11.072-7-14.527m7-7.602c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602"/>
                    </svg>
                    {t('LOCATION')}
                  </a>
                  <a
                    href='mailto:info@xplor.global'
                    className='get-in-touch-item'
                  >
                    <svg className='icon icon-mail'>
                      <path
                        d='M29,24 C30.65625,24 32,22.65625 32,21 L32,3 C32,1.34375 30.65625,0 29,0 L3,0 C1.34375,0 0,1.34375 0,3 L0,21 C0,22.65625 1.34375,24 3,24 L29,24 Z M16,16 C14.5499878,16.0250244 12.4625244,14.0062256 11.4124756,13.1687622 C5.32501221,8.33752441 3.36877441,6.74377441 2,5.58752441 L2,3 C2,2.45001221 2.45001221,2 3,2 L29,2 C29.5499878,2 30,2.45001221 30,3 L30,5.58752441 C28.6312256,6.74377441 26.6749878,8.33752441 20.5875244,13.1687622 C19.53125,14.0062256 17.4500122,16.0250244 16,16 Z M29,22 L3,22 C2.45001221,22 2,21.5499878 2,21 L2,8.1875 C3.42498779,9.35626221 5.67498779,11.1624756 10.1687622,14.7312622 C11.4500122,15.7562256 13.7125244,18.0125122 16,18 C18.2750244,18.0187378 20.5187378,15.78125 21.8312378,14.7312622 C26.3250122,11.1624756 28.5750122,9.35626221 30,8.1875 L30,21 C30,21.5499878 29.5499878,22 29,22 Z'
                        id='mail'
                        fill='#fff'
                        fillRule='nonzero'
                      ></path>
                    </svg>
                    {t('MAIL')}
                  </a>
                </div>
                <div className="get-in-touch-items">
                <a
                    href='https://wa.me/971501571020'
                    className='get-in-touch-item'
                    target="_blank"
                    style={{
                      justifyContent: 'center',
                      marginTop: '25px'
                    }}
                  >
                    <svg className="icon icon-whatsapp">
                     <style type="text/css">
                      </style>
                      <path fill='#fff' d="M0,24 L6.30536761,22.3446219 C8.0410505,23.2928467 9.99640765,23.7910505 11.9892753,23.7910505 L11.9946638,23.7910505 C18.546439,23.7910505 24,18.4553571 24,11.8981934 C24,8.72141811 22.6499895,5.73747907 20.4053781,3.48747907 C18.1607143,1.23747907 15.171439,0 11.9946638,0 C5.4375,0 0.101806641,5.33569336 0.101806641,11.8928571 C0.101806641,13.9874791 0.648193359,16.0339181 1.6875,17.8392857 L0,24 Z M11.9946638,21.7875105 C10.2160819,21.7875105 8.47501046,21.3107038 6.9589495,20.4107143 L6.60001046,20.1964286 L2.86073521,21.1767753 L3.85714286,17.5285819 L3.62140765,17.1535819 C2.63033622,15.578561 2.11073521,13.7625209 2.11073521,11.8928571 C2.11073521,6.44463239 6.54643903,2.00892857 12,2.00892857 C14.641061,2.00892857 17.1214076,3.03751046 18.9857352,4.90712193 C20.8500105,6.77678571 21.9964076,9.25713239 21.99109,11.8981934 C21.99109,17.3518066 17.4428362,21.7875105 11.9946638,21.7875105 Z M15.8035714,17.5660924 C16.3767962,17.4803467 17.5607038,16.8482143 17.8071638,16.1517857 C18.0535714,15.4553571 18.0535714,14.8607352 17.9785505,14.7374791 C17.9089181,14.6035505 17.7106934,14.5285819 17.4160505,14.3839286 C17.1214076,14.233939 15.6589181,13.516061 15.3857247,13.4196429 C15.1124791,13.3178362 14.9143066,13.2696533 14.7160819,13.5696324 C14.5178571,13.8696638 13.9500209,14.5339181 13.7731934,14.7374791 C13.6018066,14.9357038 13.4249791,14.9624895 13.1303362,14.8125 C11.3839286,13.9392962 10.2374791,13.2535924 9.08569336,11.2767857 C8.78037807,10.7517962 9.39106097,10.7893066 9.9589495,9.65358189 C10.0553676,9.45535714 10.0071324,9.28391811 9.93216378,9.13392857 C9.85714286,8.98393903 9.26252093,7.5214495 9.01606097,6.92677525 C8.77498954,6.34821429 8.52858189,6.42857143 8.34641811,6.41784668 C8.17497907,6.40712193 7.97680664,6.40712193 7.77858189,6.40712193 C7.58035714,6.40712193 7.25892857,6.48214286 6.98573521,6.77678571 C6.71248954,7.07676479 5.94642857,7.79464286 5.94642857,9.25713239 C5.94642857,10.7196219 7.01252093,12.1339286 7.15712193,12.3321533 C7.30716378,12.5303781 9.25179618,15.5303781 12.2357352,16.8214286 C14.1214076,17.6357247 14.8607352,17.7053571 15.8035714,17.5660924 Z" id="whatsapp" fill-rule="nonzero"></path>
                    </svg>
                    {t('WHATSAPP')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </InView>
  );
};

export default RegisterForm;
